export const translations = {
  'Active navigation element': {
    de: 'Aktives Navigationselement',
    fr: 'Élément de navigation actif',
    it: 'Elemento di navigazione attivo',
  },
  'Close overlay': {
    de: 'Overlay Schliessen',
    fr: 'Fermer la superposition',
    it: 'Chiudi sovrapposizione',
  },
  'Current language is English': {
    de: 'Die aktuelle Sprache ist Deutsch',
    fr: 'La langue actuelle est le français',
    it: "La lingua corrente è l'italiano",
  },
  'Change language': {
    de: 'Sprache wechseln',
    fr: 'Changer de langue',
    it: 'Cambia lingua',
  },
  'Go to main content': {
    de: 'Zum Hauptinhalt springen',
    fr: 'Aller au contenu principal',
    it: 'Vai al contenuto principale',
  },
  'Go to search': {
    de: 'Zur Suche springen',
    fr: 'Aller à la recherche',
    it: 'Vai alla ricerca',
  },
  'Go to login': {
    de: 'Zum Login springen',
    fr: 'Aller au login',
    it: 'Vai al login',
  },
  'Open menu': {
    de: 'Menü öffnen',
    fr: 'Ouvrir le menu',
    it: 'Apri il menu',
  },
  'Navigate on post.ch': {
    de: 'Navigieren auf post.ch',
    fr: 'Naviguer sur post.ch',
    it: 'Navigate su post.ch',
  },
  'Skip Links': {
    de: 'Sprung Links',
    fr: 'Sauter les liens',
    it: 'Salta i link',
  },
  'Intermediary links': {
    de: 'Intermediäre Links',
    fr: 'Liens intermédiaires',
    it: 'Collegamenti intermedi',
  },
};
